import * as Types from '../graphql.generated';

export type Ad_Targeting_FragmentFragment = {
    __typename?: 'AdTargeting';
} & Pick<
    Types.AdTargeting,
    | 'activity'
    | 'areaName'
    | 'bedsMax'
    | 'bedsMin'
    | 'brand'
    | 'brandPrimary'
    | 'countyAreaName'
    | 'countryCode'
    | 'currencyCode'
    | 'listingsCategory'
    | 'outcode'
    | 'outcodes'
    | 'page'
    | 'postalArea'
    | 'priceMax'
    | 'priceMin'
    | 'propertyType'
    | 'regionName'
    | 'resultsSort'
    | 'searchLocation'
    | 'searchResultsCount'
    | 'section'
    | 'totalResults'
    | 'url'
    | 'viewType'
>;

export const Ad_Targeting_FragmentFragmentDoc = `
    fragment AD_TARGETING_FRAGMENT on AdTargeting {
  activity
  areaName
  bedsMax
  bedsMin
  brand
  brandPrimary
  countyAreaName
  countryCode
  currencyCode
  listingsCategory
  outcode
  outcodes
  page
  postalArea
  priceMax
  priceMin
  propertyType
  regionName
  resultsSort
  searchLocation
  searchResultsCount
  section
  totalResults
  url
  viewType
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
